import { useRef } from 'react';
import PropTypes from 'prop-types';
import { mergeProps, useFocusRing, useTableRow } from 'react-aria';
import styles from './TableRow.module.scss';

const TableRow = ({ item, children, state, className, ...props }) => {
    const ref = useRef();
    const isSelected = state?.selectionManager?.isSelected(item?.key);
    const { rowProps, isPressed } = useTableRow(
        {
            node: item
        },
        state,
        ref
    );
    const { isFocusVisible, focusProps } = useFocusRing();

    return (
        <tr
            className={[
                'govuk-table__row',
                styles.row,
                isFocusVisible ? styles.focus : null,
                isPressed ? styles.pressed : null,
                isSelected ? styles.selected : null,
                className
            ].join(' ')}
            {...mergeProps(rowProps, focusProps)}
            ref={ref}
            data-testid={props['data-testid'] ? props['data-testid'] + '.tr' : null}
        >
            {children}
        </tr>
    );
};

TableRow.propTypes = {
    item: PropTypes.any,
    children: PropTypes.any,
    state: PropTypes.object,
    className: PropTypes.string,
    'data-testid': PropTypes.string
};

export default TableRow;
